// 证人管理
import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'

const baseUrl = `/${systemConfig.businessPrefix}/identificationWitness/gl/v1.0.0`
const addFileUrl = `${systemConfig.businessPrefix}/identificationWitnessSignature/gl/v1.0.0`

// 证人列表
export function getWitnessList(data) {
    return request({
        url: `${baseUrl}/selectByCaseId`,
        method: 'post',
        data
    })
}

// 新增证人
export function addWitness(data) {
    return request({
        url: `${baseUrl}/add`,
        method: 'post',
        data
    })
}

// 删除证人
export function deleteWitness(data) {
    return request({
        url: `${baseUrl}/delete`,
        method: 'post',
        data
    })
}

// 发送证明通知
export function sendWitnessNotice(data) {
    return request({
        url: `${baseUrl}/sendNotice`,
        method: 'post',
        data
    })
}

// 删除证明文件
export function deleteWitnessFile(data) {
    return request({
        url: `${baseUrl}/deleteFile`,
        method: 'post',
        data
    })
}

// 预览/下载证明文件（blob）
export function downloadWitnessFile(data) {
    return request({
        url: `${baseUrl}/download`,
        method: 'post',
        data,
        responseType: 'blob'
    })
}
//新增材料证明
export function addWitnessFile(data) {
    return request({
        url: `${addFileUrl}/add`,
        method: 'post',
        data
    })
}
//编辑材料证明
export function updateWitnessFile(data) {
    return request({
        url: `${addFileUrl}/update`,
        method: 'post',
        data
    })
}
// 证明材料删除
export function deleteWitnessSignature(data) {
    return request({
        url: `${addFileUrl}/delete`,
        method: 'post',
        data
    })
}

//发送通知
export function sendNotice(data) {
    return request({
        url: `${addFileUrl}/send`,
        method: 'post',
        data
    })
}